import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/base/SEO';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import LatestArticles from './components/LatestArticles';
import MembershipPromo from './components/MembershipPromo';
import FAQSection from './components/FAQSection';

export default function Home() {
  const homeSchema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '麻豆在线',
        url: 'https://www.madouzx.com',
        description: '麻豆在线为用户提供高清正版影视内容，海量优质资源随时在线畅享。',
        email: 'support@madouzx.com',
        telephone: '400-888-8888',
        address: {
          '@type': 'PostalAddress',
          addressLocality: '北京',
          addressRegion: '朝阳区',
          streetAddress: '光华路数字内容产业园',
        },
      },
      {
        '@type': 'WebSite',
        name: '麻豆在线',
        url: 'https://www.madouzx.com',
        description: '官方正版高清影视内容平台',
      },
      {
        '@type': 'WebPage',
        name: '麻豆在线-首页',
        description: '麻豆在线官方正版内容平台入口，提供高清影视在线观看、最新资讯、内容导航与会员服务。',
        url: 'https://www.madouzx.com/',
      },
    ],
  };

  return (
    <>
      <SEO
        title="麻豆在线-官方正版内容平台入口 | 高清影视在线观看"
        description="麻豆在线为用户提供高清正版影视内容，海量优质资源随时在线畅享。汇聚最新资讯、内容导航与会员服务，安全稳定，极速加载，立即体验麻豆在线全平台服务。"
        keywords="麻豆在线,麻豆在线观看,麻豆在线高清,麻豆在线最新内容,麻豆在线会员,麻豆在线官方入口,麻豆在线资源导航"
        canonicalUrl="https://www.madouzx.com/"
        schema={homeSchema}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedArticles />
        <MembershipPromo />
        <LatestArticles />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}